// ---------------------------------------------------------------------------
// SINGLE MEDIA SWAP POINT.
// Everything below is DEMONSTRATION MATERIAL pending licence clearance — each
// frame is a treatment example, never client work. Replace paths here when
// real client material arrives; nothing else needs touching.
// Stills live in /public/media as -800/-1600 .webp with .jpg fallbacks.
// Films are silent MP4s, ≤4MB each. Where a still pairs with a film, the
// still is the film's true first frame — the claim on the page stays literal.
// ---------------------------------------------------------------------------

const base = "/media";

export const stills = {
  S01: { id: "S01", base: `${base}/S01`, aspect: "21/9", type: "Pool & exterior", alt: "Demonstration frame — cliffside infinity pool at blue hour" },
  S02: { id: "S02", base: `${base}/S02`, aspect: "4/3", type: "Rooms", alt: "Demonstration frame — suite interior in morning light" },
  S03: { id: "S03", base: `${base}/S03`, aspect: "4/5", type: "Dining", alt: "Demonstration frame — chef's counter at night" },
  S04: { id: "S04", base: `${base}/S04`, aspect: "4/5", type: "Wellness", alt: "Demonstration frame — stone hammam and cold plunge" },
  S05: { id: "S05", base: `${base}/S05`, aspect: "16/9", type: "Aerial", alt: "Demonstration frame — aerial view of overwater villas" },
  S06: { id: "S06", base: `${base}/S06`, aspect: "3/2", type: "Arrival", alt: "Demonstration frame — arched colonnade at dusk" },
  S07: { id: "S07", base: `${base}/S07`, aspect: "16/9", type: "Landscape", alt: "Demonstration frame — villa terrace above an alpine valley" },
  S08: { id: "S08", base: `${base}/S08`, aspect: "4/5", type: "Guest moment", alt: "Demonstration frame — guest on a terrace at sunrise" },
  S09: { id: "S09", base: `${base}/S09`, aspect: "1/1", type: "Detail", alt: "Demonstration frame — cocktail on a brass tray" },
  S10: { id: "S10", base: `${base}/S10`, aspect: "21/9", type: "Landscape · night", alt: "Demonstration frame — desert pavilions at night" },
  S11: { id: "S11", base: `${base}/S11`, aspect: "4/5", type: "Bath", alt: "Demonstration frame — marble bathroom with stone bath" }, // spare
  S12: { id: "S12", base: `${base}/S12`, aspect: "16/9", type: "Beach club", alt: "Demonstration frame — beach club in daylight" },
  // Wave two + three (S15/S17/S18/S21 are the first frames of their films)
  S13: { id: "S13", base: `${base}/S13`, aspect: "3/2", type: "Destination", alt: "Demonstration frame — clifftop terrace over a coastal village at dusk" },
  S14: { id: "S14", base: `${base}/S14`, aspect: "3/2", type: "Courtyard", alt: "Demonstration frame — courtyard fountain at golden hour" },
  S15: { id: "S15", base: `${base}/S15`, aspect: "16/9", type: "Dining", alt: "Demonstration frame — the final piece placed at the counter" },
  S16: { id: "S16", base: `${base}/S16`, aspect: "2/3", type: "Interiors", alt: "Demonstration frame — grand staircase in a heritage lobby" },
  S17: { id: "S17", base: `${base}/S17`, aspect: "16/9", type: "Guest moment", alt: "Demonstration frame — guest at the window with a morning cup" },
  S18: { id: "S18", base: `${base}/S18`, aspect: "16/9", type: "Arrival", alt: "Demonstration frame — the door held open at dusk" },
  S19: { id: "S19", base: `${base}/S19`, aspect: "3/2", type: "Pool · sunset", alt: "Demonstration frame — infinity pool at sunset" },
  S20: { id: "S20", base: `${base}/S20`, aspect: "2/3", type: "Spa", alt: "Demonstration frame — stone spa by candlelight" },
  S21: { id: "S21", base: `${base}/S21`, aspect: "16/9", type: "Market", alt: "Demonstration frame — hands sorting fruit at a morning market" },
  S22: { id: "S22", base: `${base}/S22`, aspect: "3/2", type: "Shore", alt: "Demonstration frame — torchlit shore at dusk" },
  // Wave four — first frames of the five ambient films (F16–F20)
  S23: { id: "S23", base: `${base}/S23`, aspect: "16/9", type: "Wellness · dawn", alt: "Demonstration frame — meditation on raked sand at dawn" },
  S24: { id: "S24", base: `${base}/S24`, aspect: "16/9", type: "Aerial · beach", alt: "Demonstration frame — aerial view of a beach club and shoreline" },
  S25: { id: "S25", base: `${base}/S25`, aspect: "16/9", type: "Dining · terrace", alt: "Demonstration frame — terrace breakfast, hands reaching for the tray" },
  S26: { id: "S26", base: `${base}/S26`, aspect: "16/9", type: "Suite · interior", alt: "Demonstration frame — a suite interior in warm evening light" },
  S27: { id: "S27", base: `${base}/S27`, aspect: "16/9", type: "Destination · desert", alt: "Demonstration frame — aerial view of a desert retreat at first light" },
  // Wave five — portrait first frames paired with the W-series films for
  // the Process ("Four steps") section and one Selected Work tile.
  W01: { id: "W01", base: `${base}/W01`, aspect: "9/16", type: "Library", alt: "Demonstration frame — a library of frames, quietly laid out" },
  W02: { id: "W02", base: `${base}/W02`, aspect: "9/16", type: "Brief", alt: "Demonstration frame — the set agreed, before anything moves" },
  W03: { id: "W03", base: `${base}/W03`, aspect: "9/16", type: "First cut", alt: "Demonstration frame — the first cut, in review" },
  W04: { id: "W04", base: `${base}/W04`, aspect: "9/16", type: "Delivery", alt: "Demonstration frame — masters and cutdowns, named for channel" },
  W05: { id: "W05", base: `${base}/W05`, aspect: "9/16", type: "Suite · portrait", alt: "Demonstration frame — an interior detail in warm light" },
};

export const films = {
  F01: `${base}/F01.mp4`,
  F02: `${base}/F02.mp4`,
  F03: `${base}/F03.mp4`,
  F04: `${base}/F04.mp4`,
  F05: `${base}/F05.mp4`,
  F06: `${base}/F06.mp4`,
  F07: `${base}/F07.mp4`,
  F08: `${base}/F08.mp4`,
  F09: `${base}/F09.mp4`,
  F10: `${base}/F10.mp4`,
  F11: `${base}/F11.mp4`,
  F12: `${base}/F12.mp4`,
  F13: `${base}/F13.mp4`,
  F14: `${base}/F14.mp4`,
  F15: `${base}/F15.mp4`,
  F16: `${base}/F16.mp4`,
  F17: `${base}/F17.mp4`,
  F18: `${base}/F18.mp4`,
  F19: `${base}/F19.mp4`,
  F20: `${base}/F20.mp4`,
  W01: `${base}/W01.mp4`,
  W02: `${base}/W02.mp4`,
  W03: `${base}/W03.mp4`,
  W04: `${base}/W04.mp4`,
  W05: `${base}/W05.mp4`,
};

// Textures — abstract stills for the ambient background layer. Nothing here
// competes with type: no horizon, no subject, no motion path. Each T-key has
// -800 / -1600 .jpg + .webp and, where paired, a locked-off L-key film.
export const textures = {
  T01: { id: "T01", base: `${base}/T01`, alt: "" },
  T02: { id: "T02", base: `${base}/T02`, alt: "" },
  T03: { id: "T03", base: `${base}/T03`, alt: "" },
  T04: { id: "T04", base: `${base}/T04`, alt: "" },
  T05: { id: "T05", base: `${base}/T05`, alt: "" },
  T06: { id: "T06", base: `${base}/T06`, alt: "" },
  T07: { id: "T07", base: `${base}/T07`, alt: "" },
  T08: { id: "T08", base: `${base}/T08`, alt: "" },
};

// Ambient loops — silent, locked-off, ≈10s. Camera never moves so they tile
// seamlessly under text at 6–9% opacity.
export const loops = {
  L01: `${base}/L01.mp4`, // water rippling  ← T01
  L02: `${base}/L02.mp4`, // linen breathing ← T02
  L03: `${base}/L03.mp4`, // palm shadows    ← T04
  L04: `${base}/L04.mp4`, // firelight       ← T06
  L05: `${base}/L05.mp4`, // steam drifting  ← T08
};

// Fifteen pairs exist; the stepper shows six. Lead with a person or an
// object moving — the hands are the most persuasive asset on the site.
// Each film here was made from the still beside it — and from nothing else.
export const pairs = [
  { id: "counter", label: "The counter", still: "S15", film: "F08" },
  { id: "terrace", label: "The terrace", still: "S25", film: "F18" },
  { id: "door", label: "The door", still: "S18", film: "F11" },
  { id: "dawn", label: "Wellness · dawn", still: "S23", film: "F16" },
  { id: "suite", label: "The suite", still: "S26", film: "F19" },
  { id: "shore", label: "Shore · torchlight", still: "S22", film: "F07" },
];

// Hero reel — the property speaks first. Wordless, wide, editorial. Each
// clip runs its full length; nothing is cut to match.
export const heroReel = [
  { film: "F17", poster: "S24", title: "Beach · morning", meta: ["S24 · ONE STILL", "SHORELINE + SHADE", "16:9 · 24 FPS", "SILENT"] },
  { film: "F19", poster: "S26", title: "The suite", meta: ["S26 · ONE STILL", "WARM INTERIOR", "16:9 · 24 FPS", "SILENT"] },
  { film: "F20", poster: "S27", title: "Destination · desert", meta: ["S27 · ONE STILL", "AERIAL DESCENT", "16:9 · 24 FPS", "SILENT"] },
  { film: "F18", poster: "S25", title: "The terrace", meta: ["S25 · ONE STILL", "HANDS + LIGHT", "16:9 · 24 FPS", "SILENT"] },
  { film: "F16", poster: "S23", title: "Wellness · dawn", meta: ["S23 · ONE STILL", "STILLNESS + WATER", "16:9 · 24 FPS", "SILENT"] },
  { film: "F04", poster: "S13", title: "Coast · dusk", meta: ["S13 · ONE STILL", "SLOW PUSH", "16:9 · 24 FPS", "SILENT"] },
];
